import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Tag, TagToUpdate } from "../types";
import { TagDB } from "./Tags";

export const updateTag = async (
  tagId: string,
  tag: TagToUpdate,
): Promise<Tag> => {
  const collectionRef = collection(db, "tags");
  await updateDoc(doc(collectionRef, tagId), tag);

  const updatedTagSnapshot = await getDoc(doc(collectionRef, tagId));

  const updatedTag = new TagDB(updatedTagSnapshot);

  return updatedTag.toTag();
};
